export default {
  common: {
    langSwitch: 'English',
    backTop: '返回顶部',
  },
  privacy: {
    title: 'CeresGo Manager 隐私政策',
    effectiveDate: '生效日期',
    effectiveDatePlaceholder: '请按实际修改',
    intro: 'CeresGo Manager（以下简称「本 App」或「我们」）由 Robo Motion, LLC 运营。我们重视您的隐私。本政策说明我们如何收集、使用、存储及保护您的个人信息。',
    section1Title: '一、我们收集的信息',
    section1_1Title: '1.1 您主动提供的信息',
    section1_1: [
      '账号与登录：手机号码、电子邮箱地址，用于注册、登录及身份验证（含验证码）。',
      '个人资料：如您填写的姓名、昵称等（若本 App 有此功能）。',
      '客服与支持：您通过客服、反馈等渠道提供的联系方式和内容。',
    ],
    section1_2Title: '1.2 我们自动收集的信息',
    section1_2: [
      '设备与使用信息：设备型号、操作系统版本、应用版本、使用时长、页面访问等，用于保障服务正常运行与体验优化。',
      '崩溃与诊断信息：我们使用 Sentry 等工具收集崩溃报告、错误日志及性能数据，用于排查问题、改进 App 稳定性。相关隐私政策：',
    ],
    section1_3Title: '1.3 您在使用功能时产生的信息',
    section1_3: [
      '补货相关：您在上传的图片（如补货凭证、现场照片），仅用于业务所需并在法律允许范围内存储与处理。',
    ],
    section1NoCollect: '我们不会收集您的精确地理位置（GPS）、通讯录、或您未主动上传的其他本地文件。',
    section2Title: '二、我们如何使用这些信息',
    section2List: [
      '提供、维护和改进本 App 服务；',
      '进行身份验证、账号与安全管理；',
      '发送验证码、必要的服务或安全相关通知（若您选择接收）；',
      '分析使用情况与崩溃数据以改进产品；',
      '处理您提交的补货记录、工单及客服请求；',
      '遵守适用法律法规或响应有权机关依法要求。',
    ],
    section2NoUse: '我们不会将您的个人信息用于与上述目的无关的营销推广，也不会向第三方出售您的个人信息。',
    section3Title: '三、信息的存储与安全',
    section3: '我们采用合理的技术与管理措施保护您的个人信息，防止未经授权的访问、使用或泄露。您的数据会在实现本政策所述目的所必需的期限内保留，或在法律要求的更长期限内保留。',
    section4Title: '四、第三方服务',
    section4Intro: '本 App 可能接入以下第三方服务，其会按各自隐私政策处理相关数据：',
    section4Sentry: 'Sentry：用于错误监控与性能分析。隐私政策：',
    section4Email: '邮件发送服务（若使用阿里云等）：用于发送验证码或系统通知。相关服务商隐私政策：',
    section4Alibaba: '阿里云隐私政策',
    section4End: '我们仅向上述服务商提供实现功能所必要的数据，并建议您查阅其隐私政策。',
    section5Title: '五、您的权利',
    section5Intro: '根据适用法律，您可能享有以下权利（具体以您所在地区法律为准）：',
    section5List: [
      '查询、更正、删除：通过本 App 内设置或联系我们在合理范围内查询、更正或删除您的个人信息。',
      '撤回同意：在适用法律允许的范围内，您可撤回此前给予的同意，我们将在法律允许范围内停止相应处理。',
      '投诉：您有权向所在地数据保护监管机构投诉。',
    ],
    section5NoAuto: '我们不会基于您的个人信息进行自动化决策（如仅靠算法做出对您产生重大影响的决定）。',
    section6Title: '六、未成年人',
    section6: '本 App 不面向未满 13 周岁（或您所在地区规定的更高年龄）的用户。我们不会故意收集该等未成年人的个人信息。如您发现我们误收了未成年人信息，请通过下文联系方式告知我们，我们将尽快删除。',
    section7Title: '七、政策更新',
    section7: '我们可能适时修订本政策，修订后的版本将在本 App 或官网发布，重大变更我们会通过应用内通知或其它适当方式提醒您。继续使用本 App 即视为接受更新后的政策。',
    section8Title: '八、联系我们',
    section8Intro: '如您对本政策或您的个人信息处理有任何疑问、意见或请求，请通过以下方式联系我们：',
    contactEmail: '电子邮件：info@robotceres.com',
    contactWeb: '官网：https://robotceres.com/ceresgo/',
    contactPhone: '',
    section8End: '我们会在合理期限内回复您的请求。',
    footerCompany: 'Robo Motion, LLC',
    footerUpdate: '本政策最后更新日期见页首。',
    sentryUrl: 'https://sentry.io/privacy/',
    sentryLinkText: 'Sentry 隐私政策',
    alibabaUrl: 'https://www.alibabacloud.com/help/en/legal/latest/alibaba-cloud-international-website-privacy-policy',
  },
}
